import { PrimeNGConfigType } from 'primeng/config';

import { KIT_PRIMENG_PT } from '../../shared/components/overlay/overlay.presets';
import { CUSTOM_THEME } from './custom-theme';
import { SMALL_SIZE_PT } from './small-size-pt';

/**
 * The one PrimeNG config the app installs. app.config.ts passes it to `providePrimeNG`, and so
 * does every spec that reads a `--p-*`-backed token, so the runtime theme sheet a spec measures is
 * the one production injects.
 */
export const PRIMENG_CONFIG: PrimeNGConfigType = {
  // Enable PrimeNG's ripple click animation app-wide. Adds a subtle
  // material-style radial wash on every supported component (buttons,
  // selectbutton, menu items, paginator nav, etc.) so click feedback
  // is visible without bespoke per-component CSS. The ripple color
  // inherits from the component's theme tokens, so dark/light + the
  // custom Aura preset keep working unchanged.
  // See: https://v20.primeng.org/configuration#ripple
  ripple: true,
  // Global overlay host — flips the config default 'self' → 'body' for every
  // overlay component that doesn't set its own appendTo; per-instance appendTo
  // props still win. Set via the top-level config signal, not
  // overlayOptions.appendTo which is a verified no-op (see primeng-config.d.ts).
  overlayAppendTo: 'body',
  theme: CUSTOM_THEME,
  pt: { ...SMALL_SIZE_PT, ...KIT_PRIMENG_PT },
};
